// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.range-datepicker {
  position: relative;
}
.range-datepicker .range-datepicker-container {
  display: flex;
}

.range-datepicker .react-datepicker-wrapper {
  display: none;
}

.range-datepicker .react-datepicker.dashboard-datepicker-calendar {
  box-shadow: 0 0 BLACK;
}
.range-datepicker .range-datepicker-test {
  position: absolute;
  background: none !important;
}
.range-datepicker .range-datepicker-popup {
  max-width: 260px;
  min-width: initial !important;
  background: #ffffff;
  border-radius: 3px !important;
  background-color: #ffffff;
  box-shadow: 0 1px 5px 0 rgba(114, 114, 114, 0.5);
}
.range-datepicker .react-datepicker-popper {
  position: relative !important;
  top: auto;
  left: auto;
  transform: none !important;
}

.range-datepicker .selection-option {
  padding: 10px;
  cursor: pointer;
}

.range-datepicker .datepicker-selections {
  padding-top: 30px;
}

.range-datepicker .selection-option.selected {
  background: #f1f3f4;
}
.range-datepicker .range-selection {
  border-radius: 5px;
  display: inline-block;
  padding: 8px;
  padding-left: 0px;
}
.range-datepicker .range-selection.opened {
  background-color: #f1f3f4;
}

.range-datepicker .react-datepicker__day--outside-month {
  visibility: hidden;
}

.range-datepicker .react-datepicker__day--in-range {
  background: #d8e5e8;
  color: initial;
}

.range-datepicker .selected-state .react-datepicker__day:hover {
  box-shadow: 0 0px 0px 1px #a8aeb5;
}

.range-datepicker .selected-date {
  box-shadow: 0 0px 0px 1px#327b8c;
}

.range-datepicker .react-datepicker__day--in-range:hover {
  background: #d8e5e8;
}

.range-datepicker .range-date {
  /* font-weight: bold; */
  background: #327b8c !important;
  color: #ffffff !important;
}
.react-datepicker__year-dropdown {
  width: 70px;
  background: #ffffff;
  border: 0;
  box-shadow: 0 1px 5px 0 rgba(114, 114, 114, 0.5);
  border-radius: 3px;
}

span.react-datepicker__year-option--selected {
  display: none;
}

.react-datepicker__year-option.react-datepicker__year-option--selected_year {
  background: #f1f3f4;
}
span.displayed-date {
  font-weight: bold;
  padding: 9px 4px;
  cursor: pointer;
}

span.displayed-date.opened {
  border-radius: 5px;
  background-color: #f1f3f4;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui-core/src/components/RangeDapicker/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,gDAAgD;AAClD;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[".range-datepicker {\n  position: relative;\n}\n.range-datepicker .range-datepicker-container {\n  display: flex;\n}\n\n.range-datepicker .react-datepicker-wrapper {\n  display: none;\n}\n\n.range-datepicker .react-datepicker.dashboard-datepicker-calendar {\n  box-shadow: 0 0 BLACK;\n}\n.range-datepicker .range-datepicker-test {\n  position: absolute;\n  background: none !important;\n}\n.range-datepicker .range-datepicker-popup {\n  max-width: 260px;\n  min-width: initial !important;\n  background: #ffffff;\n  border-radius: 3px !important;\n  background-color: #ffffff;\n  box-shadow: 0 1px 5px 0 rgba(114, 114, 114, 0.5);\n}\n.range-datepicker .react-datepicker-popper {\n  position: relative !important;\n  top: auto;\n  left: auto;\n  transform: none !important;\n}\n\n.range-datepicker .selection-option {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.range-datepicker .datepicker-selections {\n  padding-top: 30px;\n}\n\n.range-datepicker .selection-option.selected {\n  background: #f1f3f4;\n}\n.range-datepicker .range-selection {\n  border-radius: 5px;\n  display: inline-block;\n  padding: 8px;\n  padding-left: 0px;\n}\n.range-datepicker .range-selection.opened {\n  background-color: #f1f3f4;\n}\n\n.range-datepicker .react-datepicker__day--outside-month {\n  visibility: hidden;\n}\n\n.range-datepicker .react-datepicker__day--in-range {\n  background: #d8e5e8;\n  color: initial;\n}\n\n.range-datepicker .selected-state .react-datepicker__day:hover {\n  box-shadow: 0 0px 0px 1px #a8aeb5;\n}\n\n.range-datepicker .selected-date {\n  box-shadow: 0 0px 0px 1px#327b8c;\n}\n\n.range-datepicker .react-datepicker__day--in-range:hover {\n  background: #d8e5e8;\n}\n\n.range-datepicker .range-date {\n  /* font-weight: bold; */\n  background: #327b8c !important;\n  color: #ffffff !important;\n}\n.react-datepicker__year-dropdown {\n  width: 70px;\n  background: #ffffff;\n  border: 0;\n  box-shadow: 0 1px 5px 0 rgba(114, 114, 114, 0.5);\n  border-radius: 3px;\n}\n\nspan.react-datepicker__year-option--selected {\n  display: none;\n}\n\n.react-datepicker__year-option.react-datepicker__year-option--selected_year {\n  background: #f1f3f4;\n}\nspan.displayed-date {\n  font-weight: bold;\n  padding: 9px 4px;\n  cursor: pointer;\n}\n\nspan.displayed-date.opened {\n  border-radius: 5px;\n  background-color: #f1f3f4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
